import { FC } from 'react';

export const genImgUrl = (scac: string) => `/carriers/${scac}.png`;

export const CarrierLogo: FC<{ scac: string }> = ({ scac }) => (
  <div className="w-20 h-full border border-gray-100 rounded flex flex-col justify-center items-center">
    <img className="w-full h-auto" src={genImgUrl(scac)} alt="" />
  </div>
);
